import { Form, Button, Spin, message } from 'antd';
import { useEngagementStore } from "./store";
import RenderFilterFields from './RenderFilterFields';
import moment from 'moment';

const Qaauditfilter = ({ visible, onClose, onApplyFilters }) => {
  const {
    allAgentQaData,
    filtersLoading,
  } = useEngagementStore();

  const [form] = Form.useForm();

  const handleFinish = (values) => {
    // Clear any existing errors before validation
    form.setFields([
      {
        name: 'auditedDate',
        errors: [],
      },
      {
        name: 'monthCount',
        errors: [],
      },
      {
        name: 'engagementType',
        errors: [],
      },
    ]);

    // if (!values.engagementType && !values.monthCount) {
    //   form.setFields([
    //     {
    //       name: 'monthCount',
    //       errors: ['Please select month count or engagement type'],
    //     },

    //     {
    //       name: 'engagementType',
    //       errors: ['Please select month count or engagement type'],
    //     },
    //   ])

    //   return
    // }

    // if (!values.monthCount) {
    //   values.monthCount = 1; // Set default monthCount to 1 if not provided
    // }

    if (values.auditedDate) {
      const startDate = values.auditedDate[0];
      const endDate = values.auditedDate[1];
      const differenceInDays = endDate.diff(startDate, 'days');

      if (differenceInDays > 30) {
        form.setFields([
          {
            name: 'auditedDate',
            errors: ['Please select a date range of 30 days or less.'],
          },
        ]);
        return;
      }
      values.auditedDate = JSON.stringify([startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')])
    };
    if (!values.auditedDate) values.auditedDate = JSON.stringify([moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]);
    // All multiselect values
    if (values.agentUserId) values.agentUserId = values.agentUserId.length > 0 ? JSON.stringify(values.agentUserId) : null;
    if (values.qaUserId) values.qaUserId = values.qaUserId.length > 0 ? JSON.stringify(values.qaUserId) : null;
    if (values.agentRmUserId) values.agentRmUserId = values.agentRmUserId.length > 0 ? JSON.stringify(values.agentRmUserId) : null;
    if (values.verdict) values.verdict = values.verdict.length > 0 ? JSON.stringify(values.verdict) : null;
    if (values.location) values.location = values.location.length > 0 ? JSON.stringify(values.location) : null;
    if (values.house) values.house = values.house.length > 0 ? JSON.stringify(values.house) : null;

    onApplyFilters(values);
    onClose();
  };

  const handleClear = () => {
    form.resetFields();
    onApplyFilters({});
    onClose();
  };

  return (
    <Spin spinning={filtersLoading}>
      <Form layout="vertical" onFinish={handleFinish} form={form}>
        <RenderFilterFields filtersData={allAgentQaData?.filters || []} />

        <div className="d-flex justify-content-between">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button onClick={handleClear}>
            Clear
          </Button>
        </div>
      </Form>
    </Spin>
  );
};

export default Qaauditfilter;
